require('../vendor/slick.min');

if($('.gallery').length) {

    $('.gallery').each(function () {

        let galleryObject = $(this).find('.gallery-object'),
            galleryOverlay = $(this).find('.gallery-overlay'),
            galleryOverlayObject = galleryOverlay.find('.gallery-overlay-object'),
            galleryOverlayContents = galleryOverlay.find('.gallery-image img'),
            galleryOverlayArrows = galleryOverlay.find('button'),
            galleryImages = galleryObject.find('.gallery-image'),
            overlayHasLoaded = false;

        galleryObject.slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            draggable: false,
            // fade: true,
            // asNavFor: galleryOverlay
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true,
                        draggable: true,
                        // fade: true,
                        // asNavFor: galleryOverlay
                    }
                },
                {
                    breakpoint: 767,
                    settings: "unslick"
                }
            ]
        });

        galleryOverlay.detach().appendTo($('body'));

        galleryOverlayObject.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            // asNavFor: galleryObject
        });

        // galleryOverlayObject.find('.slide-image-container').each(function () {
        //     let image = $(this).find('img');
        //     $(this).find('.image-details').css('max-width', image.width() + 'px');
        // });

        galleryImages.on('click', function () {
            let index = $(this).data('slick-index');
            showOverlay();
            galleryOverlayObject.slick('slickGoTo', index);
        });

        function showOverlay() {
            galleryOverlay.addClass('showing');
            setTimeout(function () {
                galleryOverlay.addClass('showing-full');
            }, 100);
            setTimeout(function () {
                if(!overlayHasLoaded) {
                    $(window).resize();
                    galleryOverlay.find('.gallery-inner').removeClass('loading');
                    overlayHasLoaded = true;
                }
            }, 450);
        }

        function hideOverlay() {
            galleryOverlay.removeClass('showing-full');
            setTimeout(function () {
                galleryOverlay.removeClass('showing');
            }, 350);
        }

        galleryOverlay.on('click', function () {
            hideOverlay();
        });

        galleryOverlayContents.on('click', function (e) {
            e.stopPropagation();
        });

        $('.slick-arrow').on('click', function (e) {
            e.stopPropagation();
        });

    });

}
